import { motion } from "framer-motion";
import { EASE } from "./Reveal";

export const MaskTitle = ({ text, className = "" }) => (
  <h1 className={className}>
    <span className="block overflow-hidden pb-[0.08em]">
      <motion.span className="block" initial={{ y: "110%" }} animate={{ y: "0%" }} transition={{ duration: 1.1, ease: EASE, delay: 0.1 }}>
        {text}
      </motion.span>
    </span>
  </h1>
);
